// extracted by mini-css-extract-plugin
export default {"box":"Products_box__3nlhW","box2":"Products_box2__q653e","contactButton":"Products_contactButton__ljf5I","boxImage":"Products_boxImage__PwwLU"};